'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {PRESENCE_STATE} from '../../../auth/services/UserPresenceService';

export function PersonItemView(props) {
  const name = props.showName ? renderName(props) : null;
  return (
    <div className={classNames('PersonItem', props.className)}>
      {props.rtl ? name : null}
      {props.avatar}
      {props.rtl ? null : name}
    </div>
  );
}

function renderName(props) {
  return (
    <div className="person-item-name-container">
      <h2 className="person-item-name">
        {props.name}
      </h2>
      {props.role ? (
        <span className={classNames('person-item-name', props.roleClass)}>
          <span>
            {props.role}
          </span>
        </span>
      ): null}
    </div>
  );
}

PersonItemView.propTypes = {
  roleClass: T.string,
  rtl: T.bool,
  showName: T.bool,

  name: T.string,
  role: T.string,

  avatar: T.element.isRequired,
};

PersonItemView.defaultProps = {
  rtl: false,
  showName: true,
};

PersonItemView.avatarClass = void 0;
// PersonItemView.avatarClass = 'PersonItem__avatar';

PersonItemView.getPresenceClass = function getPresenceClass(state) {
  switch (state) {
    case PRESENCE_STATE.ONLINE:
      return 'online-icon online-icon-available';
    case PRESENCE_STATE.AWAY:
      return 'online-icon online-icon-away';
    default:
      return 'online-icon';
  }
};



// WEBPACK FOOTER //
// ./src/js/personnel/components/PersonItem/PersonItemView.js